import { useGetBookingQuery, useGetUserBookingQuery } from 'generated/graphql'
import { usePermission } from 'providers/PermissionProvider'

export const useBookingData = (bookingId?: string) => {
  const [isAllowedToViewBookingFee] = usePermission('ViewBookingFeeInfoMargin')

  const { data: adminBookingData, loading: adminBookingLoading } = useGetBookingQuery({
    fetchPolicy: 'cache-only',
    variables: { bookingId: Number(bookingId) },
    skip: !isAllowedToViewBookingFee || !bookingId,
  })

  const { data: userBookingData, loading: userBookingLoading } = useGetUserBookingQuery({
    fetchPolicy: 'cache-only',
    variables: { bookingId: Number(bookingId) },
    skip: isAllowedToViewBookingFee || !bookingId,
  })

  const booking = adminBookingData?.booking ?? userBookingData?.userBooking
  const loading = adminBookingLoading || userBookingLoading

  return {
    booking,
    loading,
    adminBookingData,
    userBookingData,
  }
}
